import { FC } from "react"
import { Cards } from "src/components/projetos/Cards";
import { pageTitle$ } from "src/framework/store/ApiEvents";

const ProjetosList: FC = () => {
    pageTitle$.next("Projetos");
    return <>
        <Cards/>
    </>
}

export { ProjetosList }